import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { Dialog } from 'components/ui/dialog';
import { DeactivateAccount } from 'features/profile/component/modals/deactivate-account/deactivate-account';
import { accountSectionClassName, accountSectionTitleClassName } from './account-styles';

/** Opens the same delete-account confirmation the Settings dialog uses. */
export function DeleteAccountCard() {
  const { t } = useTranslation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <section
      className={cn(
        accountSectionClassName,
        'flex flex-col gap-3 px-6 py-5 sm:flex-row sm:items-center sm:justify-between'
      )}
    >
      <div className="flex min-w-0 flex-col gap-0.5">
        <h2 className={accountSectionTitleClassName}>
          {t('ACCOUNT_DELETE_ACCOUNT', { defaultValue: 'Delete account' })}
        </h2>
        <p className="text-sm text-grey-500 dark:text-muted-foreground">
          {t('ACCOUNT_DELETE_ACCOUNT_HINT', {
            defaultValue: 'Permanently removes your account, your chats and your agents.',
          })}
        </p>
      </div>
      <button
        type="button"
        onClick={() => setIsDialogOpen(true)}
        className="h-10 shrink-0 self-start rounded-full border border-error-700 bg-true-white px-4 text-sm font-medium leading-body text-error-700 hover:bg-error-background sm:self-auto dark:bg-card"
      >
        {t('ACCOUNT_DELETE_ACCOUNT', { defaultValue: 'Delete account' })}
      </button>
      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DeactivateAccount onClose={() => setIsDialogOpen(false)} />
      </Dialog>
    </section>
  );
}
